<template>
  <div class="flex flex-between wrap">
    <div class="flex flex-between width-100">
      <div class="notification-date">
        {{ item.dateText }}
      </div>
      <div>
        <sButton
          v-if="mode === 'card'"
          :class="{'opacity-5': item.viewed}"
          :color="item.viewed ? 'grey' : 'var(--black-color)'"
          :disabled="item.viewed"
          :icon="item.viewed === null ? 'loading' : (item.viewed ? 'mail-open' : 'mail')"
          icon-size="18px"
          :loading="item.viewed === null"
          small
          type="text"
          @click.prevent.stop="$emit('changeViewed', item)"/>
        <sButton
          v-if="mode === 'modal'"
          icon="cross"
          icon-size="18px"
          small
          type="text"
          @click="$emit('close')"/>
      </div>
    </div>
    <TooltipedText
      v-if="item.entity"
      ref="TooltipedText"
      class="notification-title"
      :line-count="1"
      :route-params="{to: {name: 'tenderitem', params: {org: item.entity.OrganizationItId, id: item.entity.entityId}}}"
      :value="`#${item.entity.Number && item.entity.Title ? item.entity.Number+' '+item.entity.Title : $t('Tenders.Tender')}`"/>
  </div>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import { mapActions } from 'vuex'

export default {
  name: 'notificationCardTitle',
  methods: {
    ...mapActions('notification', ['changeState' ]),
  },
  props: {
    item: {
      type: Object
    },
    mode: {
      type: String,
      default: 'card'
    }
  },
  components: {
    TooltipedText
  }
}
</script>
<style scoped lang="scss">
.notification-date {
  color: var(--text-color);
  margin: auto 0;
  opacity: 0.5;
  font-size: 12px;
}
.notification-title {
  margin: 5px 0 10px 0;
  text-decoration: underline !important;
  text-align: left;
  font-weight: 500;
  display: block;
}
</style>
